<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  modelValue: {
    type: [Number, String],
    default: 0
  }
});

const emit = defineEmits(['update:modelValue']);

const internalValue = ref(props.modelValue.toString());

// Synchroniser avec le parent si modelValue change
watch(
  () => props.modelValue,
  (newVal) => {
    internalValue.value = newVal.toString();
  }
);

function addChar(char) {
  if (char === '⌫') {
    internalValue.value = internalValue.value.slice(0, -1) || '0';
  } else if (char === '.') {
    if (!internalValue.value.includes('.')) {
      internalValue.value += '.';
    }
  } else {
    if (internalValue.value === '0') {
      internalValue.value = char;
    } else {
      internalValue.value += char;
    }
  }

  // Émettre une vraie valeur numérique si possible
  const numericValue = Number(internalValue.value);
  emit(
    'update:modelValue',
    isNaN(numericValue) ? internalValue.value : numericValue
  );
}
</script>

<template>
  <div class="grid grid-cols-3 gap-2">
    <div
      v-for="btn in [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '.',
        '0',
        '⌫'
      ]"
      :key="btn"
      class="text-2xl flex items-center justify-center py-5 ripple bg-white rounded-xl"
      @click="addChar(btn)"
    >
      {{ btn }}
    </div>
  </div>
</template>
